import * as React from "react";
import * as PropTypes from "prop-types";
import s from "./CustomIcon.module.css";
import * as branch from "../../ts/branches";
import classNames from "classnames";

export type CustomIconProps = {
    onClick: () => void;
    icon?: branch.ExtendedBranchCode;
    imagePath?: string;
    hidden?: boolean;
    as?: keyof HTMLElementTagNameMap;
    screenReaderText?: string;
} & React.ButtonHTMLAttributes<HTMLElement>;

const CustomIcon: React.FC<CustomIconProps> = (props: CustomIconProps) => {
    const { onClick, icon, hidden, as, screenReaderText, ...rest } = props;
    const isCustomIcon = icon === "TFALL" ? true : false;
    const selectedIcon =
        !isCustomIcon && icon ? branch.branchIcons[icon] : null;
    const iconClasses = classNames(
        selectedIcon,
        icon
            ? {
                  [s[icon]]: icon,
              }
            : null,
    );
    const customContainerClasses = classNames(s["custom-icon__container"], {
        [s["custom-icon__container--custom-icon"]]: isCustomIcon,
    });

    return (
        // @ts-ignore - JSX element type 'Tag' does not have any construct or call signatures.

        <div className={customContainerClasses} {...rest}>
            {!!selectedIcon && <i className={iconClasses}></i>}
            {isCustomIcon && (
                <img
                    src="/icons/petroleum/TF.svg"
                    className={iconClasses}
                    alt={screenReaderText}
                />
            )}
        </div>
    );
};

CustomIcon.propTypes = {
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.oneOf([
        ...branch.newBranchCodes,
    ] as branch.ExtendedBranchCodeArrayType[]),
    hidden: PropTypes.bool,
    as: PropTypes.oneOf(["button", "a", "div", "span"]),
    screenReaderText: PropTypes.string,
};

export default CustomIcon;
